// extracted by mini-css-extract-plugin
module.exports = {"main":"var(--c-main)","selection":"#efefef","background-grey-alpha-light":"rgba(130,130,130,.2)"};